import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ProjectCarousel.css';

// Import portfolio images
import CloverCover from './Portfolio/Design/img/clover-cover.png';
import MD99Cover from './Portfolio/Design/img/md99-cover.png';
import IdealExperienceCover from './Portfolio/Design/img/ideal-experience-cover.png';
import DDSLogomark from './img/dds-logomark-slide-black.png';
import SurveyDataVizCover from './img/survey-datavisualization-article.png';

const ProjectCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const projects = [
    {
      title: "Ideal GenAI Experience",
      description: "Research study exploring the ideal user experience for generative AI tools. Comprehensive analysis of existing platforms and user needs.",
      status: "Research Complete",
      link: "/ideal-experience",
      image: IdealExperienceCover
    },
    {
      title: "Decoding Design Systems",
      description: "An interactive educational platform that breaks down complex design system concepts into digestible lessons for designers and developers.",
      status: "In Development",
      link: "https://decoding-design-systems.web.app/",
      image: DDSLogomark,
      isExternal: true
    },
    {
      title: "Clover",
      description: "A mobile app for golf coaches and teams to track performance, manage schedules, and communicate. Features include scorecard uploads, team statistics, and integrated messaging.",
      status: "UX Research & Prototype",
      link: "/clover",
      image: CloverCover
    },
    {
      title: "Survey of Data Visualization Tools [2025]",
      description: "Comprehensive analysis of modern data visualization tools and libraries. Comparing features, performance, and use cases across the data viz ecosystem.",
      status: "Published on Medium",
      link: "https://medium.com/@jmcrawforddesign/survey-of-data-visualization-tools-2025-f818da168418",
      image: SurveyDataVizCover,
      isExternal: true,
      pdfLink: "/docs/Data%20Visualization%20Survey%20-%202025.pdf",
      customButtonText: "Full Article"
    },
    {
      title: "MyDesign99",
      description: "A web-based platform that enables developers to create and deploy dynamic KPI graphics with minimal effort. Bridges data visualization and web development for instant performance metric integration.",
      status: "Design System Complete",
      link: "/md99",
      image: MD99Cover
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % projects.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [projects.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="project-carousel">
      <div className="carousel-container">
        {projects.map((project, index) => (
          project.isExternal ? (
            <div
              key={index}
              className={`carousel-slide ${index === currentSlide ? 'active' : ''} ${
                index < currentSlide ? 'previous' : ''
              } ${index > currentSlide ? 'next' : ''}`}
            >
              <div className="slide-content">
                <div className="slide-image-wrapper">
                  <img 
                    src={project.image} 
                    alt={project.title}
                    className="slide-image"
                  />
                  <div className="slide-overlay"></div>
                </div>
                <div className="slide-text-content">
                  <h3 className="slide-title">{project.title}</h3>
                  <p className="slide-description">{project.description}</p>
                  <div className="slide-status">{project.status}</div>
                  <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    {project.pdfLink && (
                      <a
                        href={project.pdfLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="button-4 button-dark"
                        style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', padding: '12px 20px', whiteSpace: 'nowrap' }}
                      >
                        <span style={{ marginRight: '8px' }}>→</span>
                        View Summary
                      </a>
                    )}
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="button-4"
                      style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', padding: '0.65rem 1.25rem', whiteSpace: 'nowrap' }}
                    >
                      {project.customButtonText || 'View Project'} <span style={{ marginLeft: '0.5rem' }}>→</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              key={index}
              className={`carousel-slide ${index === currentSlide ? 'active' : ''} ${
                index < currentSlide ? 'previous' : ''
              } ${index > currentSlide ? 'next' : ''}`}
            >
              <div className="slide-content">
                <div className="slide-image-wrapper">
                  <img 
                    src={project.image} 
                    alt={project.title}
                    className="slide-image"
                  />
                  <div className="slide-overlay"></div>
                </div>
                <div className="slide-text-content">
                  <h3 className="slide-title">{project.title}</h3>
                  <p className="slide-description">{project.description}</p>
                  <div className="slide-status">{project.status}</div>
                  <Link
                    to={project.link}
                    className="button-4 button-dark"
                    style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', padding: '12px 20px', whiteSpace: 'nowrap', alignSelf: 'flex-start' }}
                  >
                    <span style={{ marginRight: '8px' }}>→</span>
                    View Project
                  </Link>
                </div>
              </div>
            </div>
          )
        ))}
      </div>

      {/* Navigation Dots */}
      <div className="carousel-dots">
        {projects.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ProjectCarousel;
